import React, { useState } from "react";
import ChevronDown from "@/assets/ChevronDown.svg";
import ChevronRight from "@/assets/ChevronRight.svg";
import Link from "next/link";
import { getMainMenu } from "@/functions/getMainMenu";
import { ensureTrailingSlash } from "@/functions/ensureTrailingSlash";

import styles from "./styles.module.scss";

/**
 * Recursive menu item
 */
function MobileNavItem({ item, itemKey, openMenus, toggle, closeNav, depth = 0 }) {
  const hasChildren = item.children && item.children.length > 0;
  const isOpen = !!openMenus[itemKey];
  const hasValidUrl = typeof item.url === "string" && item.url.trim() !== "";

  return (
    <div className={`${styles.mobileNavItem}`}>
      <div className={`${styles.mobileNavRow} ${isOpen ? styles[`backgroundRow-${depth}`] : ""}`}>
        {hasValidUrl ? (
          <Link
            href={ensureTrailingSlash(item.url)}
            className={`${styles.mobileNavLink} ${isOpen ? styles.active : ""}`}
            onClick={closeNav}
          >
            {item.title}
          </Link>
        ) : (
          <span className={styles.mobileNavLabel}>{item.title}</span>
        )}
        {hasChildren && (
          <button type="button" className={styles.mobileNavToggle} onClick={() => toggle(itemKey)}>
            <ChevronRight className={isOpen ? styles.rotate : ""} />
          </button>
        )}
      </div>
      {hasChildren && (
        <div className={`${styles.mobileSubmenu} ${isOpen ? styles.open : ""} ${styles[`depth-${depth}`]}`}>
          {item.children.map((child, index) => (
            <MobileNavItem
              key={`${itemKey}-${index}`}
              item={child}
              itemKey={`${itemKey}-${index}`}
              openMenus={openMenus}
              toggle={toggle}
              depth={depth + 1}
              closeNav={closeNav}
            />
          ))}
        </div>
      )}
    </div>
  );
}

export default function SiteHeaderNavMobile() {
  const nav = getMainMenu();
  const [openMenus, setOpenMenus] = useState({});

  /**
   * Toggle a menu and close all its descendants when collapsing
   */
  const toggle = (key) => {
    setOpenMenus((prev) => {
      const isCurrentlyOpen = !!prev[key];

      // 🔹 CASE 1: CLOSING the same menu
      if (isCurrentlyOpen) {
        const next = { ...prev };

        // remove this key and all its descendants
        Object.keys(prev).forEach((k) => {
          if (k === key || k.startsWith(key + "-")) {
            delete next[k];
          }
        });

        return next;
      }

      // 🔹 CASE 2: OPENING a menu (close others, keep ancestors)
      const next = {};
      const parts = key.split("-");
      let path = "";

      parts.forEach((part, index) => {
        path = index === 0 ? part : `${path}-${part}`;
        next[path] = true;
      });

      return next;
    });
  };

  const closeNav = () => {
    setOpenMenus({});

    const navbarCollapse = document.getElementById("responsive-navbar-nav");
    const toggler = document.querySelector(".navbar-toggler");

    if (navbarCollapse?.classList.contains("show") && toggler) {
      toggler.click(); // ✅ this keeps Bootstrap state in sync
    }
  };

  return (
    <nav className="mobile-nav">
      {nav.map((item, index) => (
        <MobileNavItem
          key={`root-${index}`}
          item={item}
          itemKey={`root-${index}`}
          openMenus={openMenus}
          toggle={toggle}
          closeNav={closeNav}
        />
      ))}
      <div className="mt-4">
        <div className="d-flex justify-content-center align-items-center text-center flex-wrap mb-4">
          <Link href={"https://mytempagency.bluearrow.co.uk/s/login"}>
            <button className="bg-primary text-white btn mx-2 mb-2">Candidate</button>
          </Link>
          <Link href={"https://myportal.bluearrow.co.uk/s/login"}>
            <button className="text-white btn mx-2 btn-custom mb-2">Client</button>
          </Link>
        </div>
      </div>
    </nav>
  );
}
